export const THEME_STORAGE_KEY = 'inspector-theme';

export const THEMES = {
    DARK: 'dark',
    LIGHT: 'light',
};

export const readTheme = () => {
    try {
        const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);

        if (storedTheme === THEMES.DARK || storedTheme === THEMES.LIGHT) {
            return storedTheme;
        }
    } catch {
        // Theme persistence is optional.
    }

    try {
        if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
            return THEMES.DARK;
        }
    } catch {
        // System preference detection is optional.
    }

    return THEMES.LIGHT;
};

export const applyTheme = (theme) => {
    document.documentElement.dataset.theme = theme;
};

export const persistTheme = (theme) => {
    try {
        window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch {
        // Theme persistence is optional.
    }
};
